<template>
  <v-col lg="8" md="6" sm="6" cols="12">
    <v-card class="reg-details-profile-card partner-info-card" flat tile
      :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'">
      <v-card-title class="pt-5 pb-5">
        <span class="titleName">Balance: <strong>${{ summary?.availableBalance < 0 ? 0 : summary?.availableBalance || 0
              }}</strong></span>
      </v-card-title>
      <v-card-actions>
        <v-card-text class="py-0 pr-0 d-flex flex-wrap">
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>Country: </span>
            <span>{{ summary?.countries?.name }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>IB Commission: </span>
            <span>${{ summary?.ib_commission || 0 }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>Reg. Time: </span>
            <span>{{ formatDate(summary?.registered_at) }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>MAM Commission: </span>
            <span>${{ summary?.mam_commission || 0 }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>Affiliate ID: </span>
            <span>{{ summary?.id }}</span>
          </v-card-subtitle>
          <!-- this is hide because total earning and ib commission field same value -->
          <!-- <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>Total Earning: </span>
            <span>${{ summary?.ib_commission }}</span>
          </v-card-subtitle> -->
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>No. Of Referral Acc: </span>
            <span>{{ summary?.referral_count || 0 }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>Total Withdrawal: </span>
            <span>${{ summary?.totalCommissionWithdraw || 0 }}</span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-4 d-flex align-center listing-v-card__subtitle flex-basis-50">
            <span>IB Link: </span>
            <span>
              <v-tooltip top color="#000">
                <template v-slot:activator="{ on }">
                  <div v-on="on" @click="copyText">
                    <span class="mb-0 d-inline-block text-truncate">
                      {{ summary?.affiliate_link }}
                    </span>
                    <v-icon color="#039de9" x-small class="icon-copy">
                      mdi-content-copy
                    </v-icon>
                  </div>
                </template>
                <span>Click to copy referral link</span>
              </v-tooltip>
            </span>
          </v-card-subtitle>
          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>Available Balance: </span>
            <span>${{ summary?.availableBalance || 0 }}</span>
          </v-card-subtitle>

          <v-card-subtitle class="pa-0 mb-4 listing-v-card__subtitle flex-basis-50">
            <span>B Book Com. rate: </span>
            <span>{{ summary?.b_book_com_rate || 0 }} %</span>
             
            <!-- <v-text-field type="number" label="Write Here" single-line solo hide-details class="custom-input"></v-text-field> -->
             
          </v-card-subtitle>

        </v-card-text>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: 'PartnerBalanceCard',
  props: {
    summary: {
      type: Object,
      required: true
    }
  },

  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
    },
    copyText() {
      const textToCopy = `${this.summary?.affiliate_link}`;
      navigator.clipboard.writeText(textToCopy);
    }
  }
};
</script>

<style>
.custom-input .v-input__slot{
  background-color:transparent !important;
  width: 140px !important;
  height: 5px !important;
  border: .1px solid #6161616b;
}
</style>